
<template>
  <div class="cbody1">
  <div class="tex">
   <div class="pricelist">
    <div class="bgbox"></div>
   <p class="ptitle">- Price List - </p>
   <img :src="bgimg" alt="" class="icon1">

   <div class="pricebox">
     <div class="price" v-for="item in listData" :key="item.id">
        <video class="wow  " playsinline style="visibility:visible;animation-duration:1.8s;" :ref="videos" data-wow-duration="1s" :src="item.content.video" :poster="item.content.img" autoplay loop muted ></video>
        <div class="tbox wow  " style="visibility:visible;animation-duration:1.8s;" :ref="videos"   data-wow-duration="1s" >
           <p class="p1">{{item.name}}</p>
           <p class="p2">{{item.content.subtitle}}</p>
             <p class="p1">價格</p>
             <p class="p2">{{item.content.price}}</p>
        </div>
     </div>

   </div>

  </div>
</div>
 </div>
</template>

<script>
import { Recommend} from '../../api/userMG'


export default {
name:'pro',
data() {
  return {
    bgimg:require("@/assets/img/hua3.png"),
    webname:'nomomo',
    webkey:'激光脫毛</br>​激光祛斑祛印',
    listData:[],
   
    params:{
    mt_id:4
    },
    observer:null

  }
},
// 註冊組件
components: {


  
},
/**
 * 數據發生改變
 */

/**
 * 創建完畢
 */
created() {
//   window.addEventListener('scroll', () => {
//     console.log(window.scrollY);
// });

},
mounted() {
  this.getdata(this.params)

this.observer = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
       
     
        if (entry.target.classList.contains('animted')) {
         
      } else {
        entry.target.classList.add('bounceIn')
        entry.target.classList.add('animted')
      }
        }
      });
    });
},

/**
 * 裏麵的方法隻有被調用才會執行
 */
methods: {
  // 獲取公司列錶
  videos(el) {
      if (el) this.observer.observe(el);
    },
  getdata(parameter) {
    this.loading = true
  

    /***
     * 調用接口，註釋上麵模擬數據 取消下麵註釋
     */
     Recommend(parameter)
    .then(res => {
      this.loading = false

      if (res.data.code != 1) {
        this.$message({
          type: 'info',
          message: res.data.message
        })
      } else {
        res.data.data.data.forEach(el => {
          el.content=JSON.parse(el.content)
      
        });
        this.listData = res.data.data.data
      
      }
    })
      .catch(err => {
        this.loading = false
        this.$message.error('菜單加載失敗，請稍後再試！')
      })
  }

 
}
}
</script>

<style>

</style>




// WEBPACK FOOTER //
// src/views/home/pro.vue